export default __webpack_public_path__ + "static/play-yellow-1d1509e9dd8ce538214bfe48ca3a5626.png";